/**
 * One-line-per-field snapshot for support when debugging date / timezone / routing issues.
 * Safe to paste into email or tickets (no tokens).
 */
export function getClientDiagnosticsText(): string {
  if (typeof window === 'undefined' || typeof Intl === 'undefined') {
    return '(SSR / no window)'
  }
  const o = Intl.DateTimeFormat().resolvedOptions()
  const now = new Date()
  let useLocalTime = ''
  let gameMode = ''
  try {
    useLocalTime = localStorage.getItem('useLocalTime') ?? ''
    gameMode = localStorage.getItem('gameMode') ?? ''
  } catch (_) {
    // ignore
  }
  const lines = [
    `href: ${window.location.href}`,
    `pathname: ${window.location.pathname}`,
    `timezone: ${o.timeZone}`,
    `locale: ${o.locale}`,
    `calendar: ${o.calendar ?? ''}`,
    `tzOffsetMin: ${now.getTimezoneOffset()}`,
    `local: ${now.toString()}`,
    `iso: ${now.toISOString()}`,
    `useLocalTime: ${useLocalTime}`,
    `gameMode: ${gameMode}`,
    `userAgent: ${typeof navigator !== 'undefined' ? navigator.userAgent : ''}`,
  ]
  return lines.join('\n')
}
